// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ursaluna_bloodmoon: PokeData = {
  "id": 10272,
  "name": "ursaluna-bloodmoon",
  "height": 24,
  "weight": 2900,
  "base_experience": 275,
  "types": [
    PokeType.GROUND,
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "leer",
    "harden",
    "lick",
    "fury-swipes",
    "rest",
    "slash",
    "snore",
    "scary-face",
    "hammer-arm",
    "payback",
    "earth-power",
    "moonblast",
    "play-nice",
    "headlong-rush",
    "blood-moon"
  ],
  "moves": [
    "scratch",
    "leer",
    "lick",
    "scary-face",
    "earth-power",
    "moonblast",
    "splash",
    "rototiller",
    "bonemerang",
    "tri-attack",
    "earthquake",
    "mud-slap",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 110,
    "item": null,
    "species": [
      {
        "name": "teddiursa",
        "order": 247,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ursaring",
        "order": 248,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 216,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ursaluna",
        "order": 901,
        "types": [
          PokeType.GROUND,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 217,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "peat-block"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "full-moon",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 142,
    "speed": 72,
    "ability_power": 186
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
